import ExamInstruction from "./ExamInstruction";
import BenefitSection from "./BenefitSection";
import SuccessStoriesSection from "./SuccessStoriesSection";

const CertificationInstructions = ({
  examData,
  benefitsData,
  successStoriesData,
}) => {
  return (
    <div className="container my-5">
      <div className="row">
        {/* Exam Instructions */}
        <ExamInstruction
          title={examData.title}
          subtitle={examData.subtitle}
          duration={examData.duration}
          questions={examData.questions}
          passScore={examData.passScore}
          validity={examData.validity}
          instructions={examData.instructions}
          topics={examData.topics}
          link={examData.link}
        />

        <div className="col-lg-4">
          {/* Benefits Section */}
          <BenefitSection
            title={benefitsData.title}
            benefits={benefitsData.benefits}
          />

          {/* Success Stories */}
          <SuccessStoriesSection
            title={successStoriesData.title}
            stories={successStoriesData.stories}
            footerNote={successStoriesData.footerNote}
          />
        </div>
      </div>
    </div>
  );
};

export default CertificationInstructions;